import { Helmet } from "react-helmet";
import { SITE_URL, person } from "../data/site";

const Seo = ({
  title,
  description,
  path = "/",
  type = "website",
  image = person.image,
  schema,
  noindex = false,
}) => {
  const url = `${SITE_URL}${path === "/" ? "" : path}`;
  const robots = noindex ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="author" content={person.name} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={person.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={person.name} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@hareesh_dev" />
      <meta name="twitter:creator" content="@hareesh_dev" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
